import * as React from 'react'

import { Box, Icon, Table, Text } from '@factorialco/deprecated-design-system'
import {
  EmployeeCustomTablesResourceValueFragment,
  EmployeeCustomTablesSchemaFieldFragment,
  EmployeeCustomTablesSchemaFragment,
  EmployeeCustomTablesSchemaResourceFieldFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { getValue } from 'modules/employees/components/CustomResources/SchemaComponent/utils/getValue'
import { RouteContext } from 'modules/employees/pages/CustomTablesListPage/context'

interface Props {
  attachableId: string
  schema: EmployeeCustomTablesSchemaFragment
  value: EmployeeCustomTablesResourceValueFragment
  currency: string
  sortedFields: EmployeeCustomTablesSchemaResourceFieldFragment[]
}

const TableBodyRowComponent = ({ schema, value, currency, sortedFields }: Props) => {
  const rootRoute = React.useContext(RouteContext)

  const {
    company: { locale: companyLocale },
  } = useCurrentSession()

  if (!rootRoute) return null

  const goToEdit = (valueId: string) => {
    return rootRoute.customTablesEdit(String(schema.id), String(valueId))
  }

  const itemValue = (
    resourceValue: EmployeeCustomTablesResourceValueFragment,
    field?: EmployeeCustomTablesSchemaFieldFragment | null
  ) =>
    getValue({
      schemaEffectiveAtId: schema.effectiveAtId,
      field,
      currency,
      resourceValue,
      companyLocale: companyLocale || '',
    })

  return (
    <Table.Row.Router to={goToEdit(value.id)}>
      {sortedFields.map((field, key) => (
        <Table.Cell key={key}>
          <Text.Normal size="300" weight="normal" color="grey800">
            {itemValue(value, field.field)}
          </Text.Normal>
        </Table.Cell>
      ))}
      <Table.Cell>
        <Box alignItems="flexEnd">
          <Icon.Medium icon="arrow-right" color="grey600" />
        </Box>
      </Table.Cell>
    </Table.Row.Router>
  )
}

export default observer(TableBodyRowComponent)
